import { GalleryReturnVariantProps } from "./gallery.variants";
import { useGallery } from "./use-gallery";
import { GalleryButtonArrow } from "./gallery-button-arrow";

export type GalleryNavProps = {
  styles: GalleryReturnVariantProps;
  loaded: ReturnType<typeof useGallery>["loaded"];
  currentSlide: ReturnType<typeof useGallery>["currentSlide"];
  instanceRef: ReturnType<typeof useGallery>["instanceRef"];
};

export const GalleryNav = ({
  styles,
  loaded,
  instanceRef,
  currentSlide,
}: GalleryNavProps) => {
  if (!loaded || !instanceRef.current) {
    return null;
  }

  return (
    <div className={styles.nav()}>
      <GalleryButtonArrow
        className={styles.button()}
        onClick={instanceRef.current?.prev}
        disabled={currentSlide === 0}
        position="left"
      />
      <GalleryButtonArrow
        className={styles.button()}
        onClick={instanceRef.current?.next}
        disabled={
          currentSlide === instanceRef.current.track.details?.slides.length - 1
        }
        position="right"
      />
    </div>
  );
};
